import Api from './Api';
const endPoint = "masterserviceconfig";
const getMasterServiceConfigs = masterserviceconfig => Api.get(`${endPoint}/masterserviceconfigurations`, masterserviceconfig);
const postMasterServiceConfig = masterserviceconfig => Api.post(`${endPoint}`, masterserviceconfig);
export {
    getMasterServiceConfigs,
    postMasterServiceConfig,

}